var _rect, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStopBusWaltti = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 8,
  x: 14.5,
  y: 22,
  fill: "#333",
  rx: 1.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 13,
  r: 11
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22.4 21H9.6A1.6 1.6 0 0 1 8 19.4V6.6A1.6 1.6 0 0 1 9.6 5h12.8A1.6 1.6 0 0 1 24 6.6v12.8a1.6 1.6 0 0 1-1.6 1.6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.05 6.6h-8.1a.81.81 0 0 0-.81.81v9.72c0 .447.363.81.81.81h8.1a.81.81 0 0 0 .81-.81V7.41a.81.81 0 0 0-.81-.81m-5.85.724h3.6v.61h-3.6zm-1.63 9.164a.62.62 0 1 1 0-1.24.62.62 0 0 1 0 1.24m6.86 0a.62.62 0 1 1 0-1.24.62.62 0 0 1 0 1.24m.62-3.236a.32.32 0 0 1-.24.312c-.564.152-2.062.504-3.81.504s-3.246-.352-3.81-.504a.32.32 0 0 1-.24-.312v-4.39c0-.178.145-.323.324-.323h7.451c.18 0 .324.145.324.324z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.19 17.925h-1.24V19.4h1.24zM20.05 17.925h-1.24V19.4h1.24z"
})));
export { SvgStopBusWaltti as ReactComponent };